import { NetworkBasePopUp } from '../NetworkBasePopUp';
import { translateFn } from '../../../../utils/translator.helper';
import { GzUpdateSecurityServerWebComponent } from './component/GzUpdateSecurityServerWebComponent';
import { CreateTaskRequest } from '../../types';
import { TaskType } from '../../../../tasks/networkTasks/types';

export class UpdateSecurityServerPopUp extends NetworkBasePopUp<GzUpdateSecurityServerWebComponent> {
  protected transformToTaskTarget = true;
  protected title = translateFn('Update Security Server');
  protected extraDialogConfigs = {
    isWindow: true,
  };

  protected customSetup() {
    this.popUpContent = new GzUpdateSecurityServerWebComponent();
  }

  protected async handleConfirmButtonClicked(event: CustomEvent): Promise<void> {
    const requestTargets = this.transformProtectedEntitiesToTargetEntities();
    const requestSpecifics = this.popUpContent.getRequestTaskSpecifics();

    const request: CreateTaskRequest = {
      settings: {
        specifics: requestSpecifics,
        targets: requestTargets,
        taskName:
          requestSpecifics.updateSvaType === Constants.Tasks.Endpoints.UPDATE_SVA_TYPE.SYSTEM
            ? translateFn('Security Server update (features)')
            : translateFn('Security Server update (OS)'),
        type: TaskType.TASK_TYPE_UPDATE_SVA_PARENT,
      },
    };

    await this.createTask(request);
  }
}
